<template>
    <div class="body" id="joinUp">
        <div class="head">
            <div class="head-title">校园智连数据大屏</div>
            <div class="nowTime">{{nowTime}}</div>
        </div>
        <div class="box">
            <div class="box-l box-img">
                <div class="box-lt">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div>
                        <div id="myEcharts1" class="statics"></div>
                    </div>
                    <div>
                        <div id="myEcharts2" class="statics"></div>
                    </div>
                </div>
                <div class="box-lb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="echart">
                        <div class="screen-title">设备健康分析</div>
                        <div id="myEcharts9" class="echartBar statics"></div>
                    </div>
                </div>
            </div>
            <div class="box-c">
                <div class="box-ct">
                    <div class="box-ctt">
                        <div class="screen-title">智能设备统计</div>
                        <div class="box-ct1">
                            <div>
                                <p class="ct1-tip">接入设备数</p>
                                <div id="myEcharts3" class="statics"></div>
                            </div>
                            <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (6).png" alt="Background">
                            <div>
                                <p class="ct1-tip">活跃度</p>
                                <div id="myEcharts4" class="statics"></div>
                            </div>
                        </div>
                        <div class="box-ct2">
                            <div>
                                <div class="ct2-name">今日活跃设备</div>
                                <div class="ct2-num">{{screenDatas.todayOnlineCount }}</div>
                            </div>
                            <div>
                                <div class="ct2-name">今日故障设备</div>
                                <div class="ct2-num">{{screenDatas.todayFaultCount }}</div>
                            </div>
                            <div>
                                <div class="ct2-name">今日使用人数</div>
                                <div class="ct2-num">{{screenDatas.todayUseCount }}</div>
                            </div>
                            <div>
                                <div class="ct2-name">学生总数</div>
                                <div class="ct2-num">{{screenDatas.studentCount }}</div>
                            </div>
                            <div>
                                <div class="ct2-name">活跃度</div>
                                <div class="ct2-num">{{screenDatas.studentUsePercent}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="box-ctb">
                        <div class="screen-title">近7日设备运行状态</div>
                        <div id="myEcharts5" class="statics"></div>
                    </div>
                </div>
                <div class="box-cb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <img src="../../assets/imgs/smartLinkBigScreen/dqiu.png" alt="Background">
                    <div class="screen-title">设备实时监控</div>
                    <div v-for="item in realTime" class="buildBtn" :style="'top:'+item.y+';left:'+item.x">
                        <div>{{item.buildingName}}（{{item.deviceCount}}）</div>
                        <div>
                            <img src="../../assets/imgs/smartLinkBigScreen/img_82.png" alt="Background">
                        </div>
                    </div>

                </div>
            </div>
            <div class="box-r">
                <div class="box-rt box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="screen-title">使用率分析</div>
                    <div class="box-use">
                        <div>
                            <div id="myEcharts6" class="usePie"></div>
                            <div>班牌使用人次</div>
                        </div>
                        <div>
                            <div id="myEcharts7" class="usePie"></div>
                            <div>消费机使用人次</div>
                        </div>
                        <div>
                            <div id="myEcharts10" class="usePie"></div>
                            <div>门禁使用人次</div>
                        </div>
                        <div>
                            <div id="myEcharts11" class="usePie"></div>
                            <div>AI体育使用人次</div>
                        </div>
                        <div>
                            <div id="myEcharts12" class="usePie"></div>
                            <div>超市消费使用人次</div>
                        </div>
                        <div>
                            <div id="myEcharts13" class="usePie"></div>
                            <div>公话使用人次</div>
                        </div>
                    </div>
                </div>
                <div class="box-rb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="table">
                        <div class="screen-title">使用时长分析</div>
                        <div id="myEcharts8" class="statics"></div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "smartLinkBigScreen",
        data() {
            return {
                query: {
                    schoolId: '',
                    openid: 'abc',
                },
                realTime: [],
                screenDatas: {},
                myCharts1: null,
                myCharts2: null,
                myCharts3: null,
                myCharts4: null,
                myCharts5: null,
                myCharts6: null,
                myCharts7: null,
                myCharts8: null,
                myCharts9: null,
                myCharts10: null,
                myCharts11: null,
                myCharts12: null,
                myCharts13: null,
                nowTime: '',
            }
        },
        created() {
            this.query.schoolId = this.$route.query.schoolId
            window.onresize = () => {
                this.myCharts1.resize();
                this.myCharts2.resize();
                this.myCharts3.resize();
                this.myCharts4.resize();
                this.myCharts5.resize();
                this.myCharts6.resize();
                this.myCharts7.resize();
                this.myCharts8.resize();
                this.myCharts9.resize();
                this.myCharts10.resize();
                this.myCharts11.resize();
                this.myCharts12.resize();
                this.myCharts13.resize();
            };
            this.nowTimes()
        },
        mounted() {
            this.funAll()
        },

        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = year + "-" + month + "-" + date + ' ' + hh + ":" + mm + ':' + ss

            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },
            funAll() {
                this.getPieChart(); //基本情况
            },
            // 基本情况
            getPieChart() {
                let url = "/zuhu1/api-dashboard/device/pieChart/v4"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data
                        this.screenDatas = datas || {}

                        let distribution = datas.distribution || {}
                        distribution = this.objDispose(distribution)
                        let distribution2 = datas.distribution2 || {}
                        distribution2 = this.objDispose(distribution2)

                        this.statistics(distribution)
                        this.statistics2(distribution2)

                        this.statistics3(datas.deviceCount)
                        this.statistics4(datas.onlinePercent)
                        this.statistics5(datas.trend)
                        this.statistics6(datas.todayUseCount1)
                        this.statistics7(datas.todayUseCount2)


                        let useTimesAnalysis = datas.useTimesAnalysis || []
                        useTimesAnalysis.map(item => {
                            item.onlineTimesH = (item.onlineTimes / 3600).toFixed(2)
                            item.screenDistanceH = (item.screenDistance / 3600).toFixed(2)
                        })
                        this.statistics8(datas.useTimesAnalysis)

                        this.statistics9()

                        let realTime = datas.realTime || []
                        realTime.map(item => {
                            item.x = (Math.random() * 70 + 10) + '%'
                            item.y = (Math.random() * 67 + 15) + '%'
                        })
                        this.realTime = realTime
                        this.statistics10()
                        this.statistics11()
                        this.statistics12()
                        this.statistics13()

                    }
                })
            },
            objDispose(obj) {
                let arr = []
                Object.entries(obj).forEach(([key, value]) => {
                    let objs = {
                        name: key,
                        value: value
                    }

                    arr.push(objs)
                });
                return arr
            },
            // 按类别分类
            statistics(datas) {
                this.myCharts1 = this.$echarts.init(document.getElementById('myEcharts1'))
                // 绘制图表
                this.myCharts1.setOption({
                    color: ['#3EECFD', '#4964F5', '#00E437', '#8BB2DE', '#ED5400', '#00A8FF', '#FDD100'],
                    title: {
                        text: '按类别分类',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 16,
                            textAlign: 'center'
                        },
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        right: '5%',
                        top: '20%',
                        textStyle: {
                            color: '#fff',
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['55%', '70%'],
                            data: datas,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            textStyle: {
                                color: '#fff',
                                fontSize: 16,
                                fontWeight: 'bold',
                                labelPosition: 'outside'
                            },
                            label: {
                                show: true,
                                formatter: '{b}: {c}' // 显示名称和数值
                            }
                        }
                    ]
                })
            },
            // 按厂商分类
            statistics2(datas) {
                this.myCharts2 = this.$echarts.init(document.getElementById('myEcharts2'))
                // 绘制图表
                this.myCharts2.setOption({
                    color: ['#ED5400', '#00A8FF', '#FDD100', '#3EECFD', '#4964F5', '#00E437', '#8BB2DE'],
                    title: {
                        text: '按厂商分类',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 16,
                            textAlign: 'center'
                        },
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        right: '5%',
                        top: '50%',
                        textStyle: {
                            color: '#fff',
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['55%', '70%'],
                            data: datas,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            textStyle: {
                                color: '#fff',
                                fontSize: 16,
                                fontWeight: 'bold',
                                labelPosition: 'outside'
                            },
                            label: {
                                show: true,
                                formatter: '{b}: {c}' // 显示名称和数值
                            }
                        }
                    ]
                })
            },
            // 接入设备数
            statistics3(deviceCount) {
                this.myCharts3 = this.$echarts.init(document.getElementById('myEcharts3'))
                // 绘制图表
                this.myCharts3.setOption({
                    color: ['#EEC50A', '#58A55C', '#F2BD42', '#F7F401', '#5087EC', '#68BBC4'],
                    title: {
                        text: deviceCount,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [{
                                name: '接入设备数', value: deviceCount
                            }],
                        }
                    ]
                })
            },
            // 活跃度
            statistics4(onlinePercent) {
                let num = this.getPercentageNumber(onlinePercent)
                this.myCharts4 = this.$echarts.init(document.getElementById('myEcharts4'))
                // 绘制图表
                this.myCharts4.setOption({
                    color: ['#F44772', '#7B889F'],
                    title: {
                        text: onlinePercent,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {name: '活跃度', value: num},
                                {name: '其他', value: 100 - num},
                            ],
                        }
                    ]
                })
            },
            getPercentageNumber(percentageStr) {
                const number = parseFloat(percentageStr.replace('%', '')); // 移除 % 并转为浮点数
                return number;
            },
            // 近7日设备运行状态
            statistics5(trend) {
                let trends = trend || []
                let dates = [], online = [], offline = []
                trends.map(item => {
                    dates.push(item.date)
                    online.push(item.online)
                    offline.push(item.offline)
                })
                this.myCharts5 = this.$echarts.init(document.getElementById('myEcharts5'))
                // 绘制图表
                this.myCharts5.setOption({
                    color: ['#00E437', '#E55A5E'],
                    legend: {
                        data: ['正常点', '停用点'],
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '20%',
                        left: '5%',
                        right: '0%',
                        bottom: '15%'
                    },
                    xAxis: {
                        type: 'category',
                        data: dates,
                        axisLabel: {
                            color: '#b9bfd0',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }

                        },
                        axisTick: {
                            color: '#b9bfd0',
                            length: 5
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#A2A8B9',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }
                        },

                    },
                    series: [
                        {
                            name: '正常点',
                            data: online,
                            type: 'line',
                            areaStyle: {
                                color: '#00E437',
                                opacity: 0.2,
                            },
                            smooth: true,
                        },
                        {
                            name: '停用点',
                            data: offline,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: '#E55A5E',
                                opacity: 0.2,
                            },

                        }
                    ]
                })
            },

            statistics6(todayUseCount1) {
                let datas = []
                if (todayUseCount1 == 0) {
                    datas = [
                        {value: todayUseCount1},
                    ]
                } else {
                    datas = [
                        {value: todayUseCount1},
                        {value: 0}
                    ]
                }
                this.myCharts6 = this.$echarts.init(document.getElementById('myEcharts6'))
                // 绘制图表
                this.myCharts6.setOption({
                    color: ['#546792', '#0B1B34'],
                    title: {
                        text: todayUseCount1 + '人',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: datas,
                        }
                    ]
                })
            },

            statistics7(todayUseCount2) {
                let datas = []
                if (todayUseCount2 == 0) {
                    datas = [
                        {value: todayUseCount2},
                    ]
                } else {
                    datas = [
                        {value: todayUseCount2},
                        {value: 0}
                    ]
                }
                this.myCharts7 = this.$echarts.init(document.getElementById('myEcharts7'))
                // 绘制图表
                this.myCharts7.setOption({
                    color: ['#CF8294', '#0B1B34'],
                    title: {
                        text: todayUseCount2 + '人',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: datas,
                        }
                    ]
                })
            },

            statistics8(useTimesAnalysis) {
                let dates = [], onlineTimesH = [], screenDistanceH = []
                useTimesAnalysis.map(item => {
                    dates.push(item.date)
                    onlineTimesH.push(item.onlineTimesH)
                    screenDistanceH.push(item.screenDistanceH)
                })
                this.myCharts8 = this.$echarts.init(document.getElementById('myEcharts8'))
                // 绘制图表
                this.myCharts8.setOption({
                    color: ['#00E437', '#E55A5E'],
                    legend: {
                        data: ['消费机在线时长', '电子班牌亮屏时长'],
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '20%',
                        left: '15%',
                        right: '5%',
                        bottom: '15%'
                    },
                    xAxis: {
                        type: 'category',
                        data: dates,
                        axisLabel: {
                            color: '#b9bfd0',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }

                        },
                        axisTick: {
                            color: '#b9bfd0',
                            length: 5
                        },
                    },
                    yAxis: {
                        type: 'value',
                        name: '小时',
                        axisLabel: {
                            color: '#A2A8B9',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }
                        },

                    },
                    series: [
                        {
                            name: '消费机在线时长',
                            data: onlineTimesH,
                            type: 'line',
                            areaStyle: {
                                color: '#00E437',
                                opacity: 0.2,
                            },
                            smooth: true,
                        },
                        {
                            name: '电子班牌亮屏时长',
                            data: screenDistanceH,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: '#E55A5E',
                                opacity: 0.2,
                            },

                        }
                    ]
                })
            },

            statistics9() {
                this.myCharts9 = this.$echarts.init(document.getElementById('myEcharts9'))
                // 绘制图表
                this.myCharts9.setOption({
                    color: ['#00E337', '#E7DBAB', '#F5CE03', '#E55A5E'],
                    legend: {
                        data: ['正常', '轻微衰减', '中度衰减', '重度衰减'],
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '20%',
                        left: '15%',
                        right: '5%',
                        bottom: '15%'
                    },
                    xAxis: {
                        type: 'category',
                        data: ['班牌', '消费机'],
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 14
                        },

                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 14
                        },
                    },
                    series: [
                        {
                            name: '正常',
                            data: [0, 0],
                            type: 'bar',
                            stack: 'total',
                        },
                        {
                            name: '轻微衰减',
                            data: [0, 0],
                            type: 'bar',
                            stack: 'total',
                        },
                        {
                            name: '中度衰减',
                            data: [0, 0],
                            type: 'bar',
                            stack: 'total',
                        },
                        {
                            name: '重度衰减',
                            data: [0, 0],
                            type: 'bar',
                            stack: 'total',
                        },
                    ]
                })
            },

            statistics10() {
                this.myCharts10 = this.$echarts.init(document.getElementById('myEcharts10'))
                // 绘制图表
                this.myCharts10.setOption({
                    color: ['#32AABE', '#0B1B34'],
                    title: {
                        text:  '0人',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics11() {
                this.myCharts11 = this.$echarts.init(document.getElementById('myEcharts11'))
                // 绘制图表
                this.myCharts11.setOption({
                    color: ['#52AC93', '#0B1B34'],
                    title: {
                        text:  '0人',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics12() {
                this.myCharts12 = this.$echarts.init(document.getElementById('myEcharts12'))
                // 绘制图表
                this.myCharts12.setOption({
                    color: ['#786851', '#0B1B34'],
                    title: {
                        text:  '0人',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics13() {
                this.myCharts13 = this.$echarts.init(document.getElementById('myEcharts13'))
                // 绘制图表
                this.myCharts13.setOption({
                    color: ['#B3AC68', '#0B1B34'],
                    title: {
                        text:  '0人',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },


        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        /*height: 1080px;*/
        height: 100%;
        background: rgb(3, 17, 51);
        overflow: hidden;
        background: url("../../assets/imgs/smartLinkBigScreen/bg.jpg") no-repeat center 0;
    }

    .head {
        height: 120px;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 38px;
        position: relative;
        background: url("../../assets/imgs/smartLinkBigScreen/topbg.png") no-repeat center 0;
        box-sizing: border-box;
    }

    .head-title {
        background: -webkit-linear-gradient(#4AF3F3, #179DF5);
        -webkit-background-clip: text;
        color: transparent;
        font-weight: bold;
    }

    .box {
        display: flex;
        /*height: 960px;*/
        height: calc(100% - 100px);
        margin-top: -20px;
    }

    .box > div {
        padding: 10px 0 0;
    }

    .box > div > div {
        width: 90%;
        margin: 0 auto 20px;
    }

    .box-l, .box-r {
        width: 32%;
    }

    .box-c {
        flex: 1;
        padding: 30px 0 0 0 !important;
    }

    .box-c > div {
        width: 96% !important;
    }

    .screen-title {
        color: #F9FEFE !important;
        /*font-weight: bold;*/
        font-size: 20px;
        padding: 20px 30px 10px;
    }


    .box-lt {
        height: 50%;
        min-height: 180px;
        position: relative;
    }

    .box-img img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .box-lt > div {
        height: 50%;
        padding: 10px 0;
        box-sizing: border-box;
    }

    .box-lb {
        height: 45%;
        position: relative;
    }

    .table {
        height: 100%;
        display: flex;
        flex-direction: column;
    }


    .table-title p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }


    .table-box > div {
        display: flex;
        color: rgb(229, 238, 227);
        justify-content: space-between;
    }

    .table-box > div:nth-child(odd) {
        background: rgb(17, 33, 62);
    }

    .table-box > div > p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .statics {
        width: 100%;
        /*height: 150px*/
        height: 100%;
    }

    .box-ct {
        height: calc(60% - 20px);
        margin-bottom: 20px;
        /*border: 1px solid red;*/
        position: relative;
        color: white;
    }

    .box-ctt {
        height: 60%;
    }

    .box-ctb {
        height: 40%;
    }

    #myEcharts5 {
        height: calc(100% - 56px);
    }

    .box-ct1 {
        display: flex;
        justify-content: space-between;
        height: calc(100% - 150px);
    }

    .box-ct1 > div {
        flex: 1;
        position: relative;
    }

    .box-ct2 {
        display: flex;
    }

    .box-ct2 > div {
        flex: 1;
        border: 1px solid #1D5A98;
        text-align: center;
    }

    .ct2-name {
        color: white;
        padding: 10px 0;
    }

    .ct2-num {
        color: #40FFED;
        font-size: 24px;
        padding: 0 0 20px 0;
    }

    .ct1-tip {
        position: absolute;
        color: #7B889F;
        top: 10px;
        left: 15px;
    }


    .box-cb {
        height: 35%;
        position: relative;
    }

    .box-rt {
        height: calc(50%);
        position: relative;
    }

    .box-rb {
        height: calc(45%);
        position: relative;
    }

    .box-use {
        position: relative;
        z-index: 10;
        height: calc(100% - 66px);
    }

    .box-use > div {
        display: inline-block;
        height: 48%;
        width: 33%;
        color: white;
        text-align: center;
    }

    .usePie {
        width: 100%;
        height: calc(100% - 30px);
    }

    .echart {
        width: 100%;
        height: 100%;
    }

    .echartBar {
        height: calc(100% - 56px);
    }

    .buildBtn {
        color: white;
        position: absolute;
        font-size: 12px;
        text-align: center;
    }

    .buildBtn img {
        position: relative !important;
        width: 10px;
        height: 10px;
        text-align: center;
    }

    .nowTime {
        color: #69E7EE;
        position: absolute;
        right: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }
</style>

